<sf-card>
    <div class="row gx-5 px-3 py-2">
        <div class="col-12">
            <h3>Parts</h3>
            <p class="text-body-secondary">Add parts via the catalog, Parts Arena, bespoke items or your favourites.</p>
            @if (gcNumber) {
                <p class="fw-bold text-success">
                    The customers main appliance GC Number is
                    <span class="text-decoration-underline">{{ gcNumber }}</span
                    >.
                </p>
            }
        </div>
        <div class="col-12">
            <div [formGroup]="form">
                <div class="d-grid d-md-block gap-1 mb-2">
                    <button
                        sfButton
                        class="me-md-1"
                        size="md"
                        color="secondary"
                        icon="magnifying-glass-plus"
                        tooltip="Search for parts in Wolseley"
                        (click)="openWolseleySearch()">
                        Catalog
                    </button>
                    <button
                        sfButton
                        class="me-md-1"
                        size="md"
                        color="secondary"
                        icon="magnifying-glass-plus"
                        tooltip="Search for parts in Parts Arena"
                        (click)="openPartsArenaSearch()">
                        Parts Arena
                    </button>

                    <button
                        sfButton
                        class="me-md-1"
                        size="md"
                        color="secondary"
                        icon="magnifying-glass-plus"
                        tooltip="Search for parts in your Bespoke Favourites"
                        (click)="openSmartquoteBespokeFavouriteSearch()">
                        Bespoke
                    </button>
                    <button
                        sfButton
                        class="me-md-1"
                        size="md"
                        color="secondary"
                        icon="magnifying-glass-plus"
                        tooltip="Search for parts in your Favourites from Wolseley"
                        (click)="openSmartQuoteFavouriteSearch()">
                        Favourites
                    </button>
                </div>

                @if (lineItems.length) {
                    <div class="smartquote-line rounded bg-light mb-2">
                        <div class="row mb-2 p-2">
                            <div class="d-none d-xl-block fw-bold col-xl-6 col-xxl-6">Product</div>
                            <div class="d-none d-xl-block fw-bold col-6 col-xl-2 col-xxl-2">Units</div>
                            <div class="d-none d-xl-block fw-bold col-xl-2 col-xxl-2">Trade Cost</div>
                            <div class="d-none d-xl-block fw-bold col-xl-2 col-xxl-2 text-end">Total</div>
                        </div>
                    </div>
                }

                <div formArrayName="lineItems">
                    @for (item of lineItems.controls; track item; let i = $index) {
                        <div class="smartquote-line rounded p-3 bg-light mb-2">
                            <ng-container [formGroupName]="i">
                                <div class="row g-2">
                                    <div class="col-12 col-xl-4 col-xxl-5">
                                        <div class="d-flex">
                                            <div class="flex-fill pe-3">
                                                <div class="d-flex">
                                                    @if (item.value.imageUrl) {
                                                        <img
                                                            [src]="item.value.imageUrl"
                                                            style="max-width: 40px"
                                                            (click)="changeDefaultImageUrl.emit(item.value.imageUrl)"
                                                            class="img-fluid me-2"
                                                            alt="Product Image" />
                                                    }
                                                    <div class="flex-fill">
                                                        <sf-input
                                                            size="sm"
                                                            inputId="description-{{ i }}"
                                                            formControlName="description"></sf-input>

                                                        @if (item.value.mpn) {
                                                            <span class="small text-muted d-block"
                                                                >MPN: {{ item.value.mpn }}</span
                                                            >
                                                        }
                                                        @if (item.value.catalogNumber) {
                                                            <span class="small text-muted d-block"
                                                                >Product Code: {{ item.value.catalogNumber }}</span
                                                            >
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-xl-none ms-auto">
                                                <a
                                                    sfButton
                                                    color="danger"
                                                    size="sm"
                                                    class="d-xl-block"
                                                    icon="trash"
                                                    (click)="removeLineItem(i)"></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xs-6 col-xl-4 col-xxl-3">
                                        <span class="d-lg-none">Quantity</span>
                                        <div class="d-flex">
                                            <div>
                                                <a
                                                    sfButton
                                                    color="danger"
                                                    size="sm"
                                                    class="d-none d-xl-inline-block me-1"
                                                    icon="trash"
                                                    (click)="removeLineItem(i)"></a>
                                            </div>
                                            <div>
                                                <sf-input-quantity
                                                    inputId="quantity-{{ i }}"
                                                    [min]="1"
                                                    size="sm"
                                                    formControlName="quantity"></sf-input-quantity>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xs-6 col-xl-2 col-xxl-2">
                                        <span class="d-xl-none">Unit Cost</span>
                                        <sf-input-money
                                            inputId="cost-{{ i }}"
                                            size="sm"
                                            formControlName="cost"></sf-input-money>
                                        @if (item.value.terms) {
                                            <p class="mb-0 small text-success fw-bold">
                                                Terms: {{ item.value.terms | currency }}
                                            </p>
                                        }
                                    </div>
                                    <div class="col-12 col-xl-2 col-xxl-2 text-end">
                                        <p class="mb-0 fw-bold">
                                            <span class="d-xl-none">Line Total: </span
                                            >{{ item.value.cost! * item.value.quantity! | currency }}
                                        </p>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</sf-card>
